import { Link } from "react-router-dom";

export default function PortalAccess() {
  return (
    <div className="min-h-screen bg-[color:hsl(var(--background))] flex items-center justify-center px-6" data-testid="portal-access-page">
      <div className="text-center max-w-md">
        <div className="overline">Subtend Studio · Portal</div>
        <h1 className="font-serif font-light mt-4" style={{ fontSize: "48px", lineHeight: 1.05 }}>
          Please use your invitation link.
        </h1>
        <p className="text-muted-foreground mt-4 text-sm">Your studio contact will have sent you a secure link by email. Open that link on this device to access your project. Links are single-use and time-limited for your security.</p>
        <p className="text-xs text-muted-foreground mt-6">Can't find it? <a href="mailto:hello@luxemediawalls.com.au" className="underline">Contact the studio</a>.</p>
        <Link to="/" className="btn-outline mt-8 inline-flex">Return home</Link>
      </div>
    </div>
  );
}
